/**
 * Meeting Modules API Endpoints
 * Handles communication with /api/v2/teacher/meeting/modules/meeting
 */

import apiClient from "../apiClient";
import { ApiResponse } from "@/types/api.types";
import { MeetingCategoriesResponse } from "@/types/meeting-modules.types";
import { getProductConfig } from "@/config/product.config";

/**
 * Fetch all meeting categories with their modules
 * GET /teacher/meeting/modules/{collectionType}
 * Note: BASE_URL already includes /api/v2/
 */
export const fetchMeetingModules =
  async (): Promise<MeetingCategoriesResponse> => {
    const { collectionType } = getProductConfig();

    const response = await apiClient.get<MeetingCategoriesResponse>(
      `/teacher/meeting/modules/${collectionType}`
    );
    // API returns array directly, not wrapped in ApiResponse
    return response;
  };
